<template>
    <Layout is-crm>
        <header class="page__top">
            <h1>Flows</h1>
        </header>
        <PaginatedResource :fetch-method="fetchFlows">
            <template
                #default="{ fetch, loading, sort, search, canLoadMore, resource: flows, isEmpty, notFound, loadMore }"
            >
                <div class="customers">
                    <Spinner v-if="loading" />
                    <FlowsTable :flows="flows" />
                    <div v-if="notFound" class="empty">
                        {{ $t('crm.customers.list.notFound') }}
                    </div>
                    <div v-if="isEmpty" class="empty">
                        {{ $t('crm.customers.list.empty') }}
                    </div>
                    <div v-if="canLoadMore">
                        <button
                            class="button button--big button--blank"
                            type="button"
                            @click="loadMore"
                        >
                            {{ $t('misc.loadmore') }}
                        </button>
                    </div>
                </div>
            </template>
        </PaginatedResource>
    </Layout>
</template>

<script>
import Layout from '@speechki-frontend/shared/ui/layout/Layout';
import PaginatedResource from '@speechki-frontend/shared/PaginatedResource';
import { WithGlobalPermission } from '@speechki-frontend/core/auth/components';

import { fetchFlows } from '../../api/flows';
import FlowsTable from '../../components/FlowsTable/FlowsTable';

export default {
    name: 'FlowsPage',
    components: {
        Layout,
        PaginatedResource,
        FlowsTable
    },
    methods: {
        fetchFlows
    }
};
</script>
